module.exports = __webpack_public_path__ + "media/img/help_center/Student_Profile_03-66ee4e7bc1554b7775ca87c02a92d6b0.jpg";